// 评级选项列表（基于 DefiSea LitePaper 的 5 级评分标准）
export const GRADE_OPTIONS = [
  { value: null, label: 'Any', minScore: null },
  { value: 'AAA', label: 'AAA (90-100)', minScore: 90 },
  { value: 'AA-A', label: 'AA-A (75-89)', minScore: 75 },
  { value: 'BBB-B', label: 'BBB-B (60-74)', minScore: 60 },
  { value: 'CCC', label: 'CCC (40-59)', minScore: 40 },
  { value: 'D', label: 'D (<40)', minScore: 0 },
];

// 根据评级获取最小分数
export function getMinScoreByGrade(grade) {
  const option = GRADE_OPTIONS.find(opt => opt.value === grade);
  return option ? option.minScore : null;
}

// 根据分数获取评级（基于 DefiSea LitePaper 的 5 级评分标准）
export function calculateGrade(score) {
  if (score === null || score === undefined || typeof score !== 'number') {
    return 'N/A';
  }
  
  // Litepaper 标准：5 级评分系统
  if (score >= 90) return 'AAA';
  if (score >= 75) return 'AA-A';
  if (score >= 60) return 'BBB-B';
  if (score >= 40) return 'CCC';
  return 'D';
}

